<template>
    <section class="service-intro" id="service-intro">
        <div class="intro-cont">
            <div class="container-md">
                <div class="text-center">
                    <h2 class="sub-title text-primary-ci">서비스 소개</h2>
                    <h3 class="text-xl">바로돌봄을 소개합니다</h3>
                    <p class="desc">
                        바로돌봄은 적극적인 의료서비스 이용이 어려운 장기요양등급인정자,<br>
                        등록장애인, 섬벽지 거주자 등 의료취약계층의 의료 접근성 향상을 위해 개발된<br>
                        <strong>국내 유일의 비대면진료 및 약배달 올인원 솔루션입니다</strong>
                    </p>
                    <a href="../../2401_soldoc_바로돌봄_서비스소개자료.pdf" class="btn-download" download>소개서 다운로드</a>
                </div>
                <iframe class="movie" src="https://www.youtube.com/embed/7KekV_rGswg" title="[바로돌봄] 요양기관 어르신 전용 비대면진료, 솔닥 바로돌봄을 소개합니다" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="user-type">
                    <div class="item">
                        <dl v-intersect>
                            <dt class="text-xl">환자 본인</dt>
                            <dd>
                                <p>병원에서 대기하는 번거로움 없이 편안한 장소와<br>
                                시간에 의사를 만날 수 있습니다.</p>
                                <p>약을 원하는 곳으로 배달 받거나, 인근 약국을<br>
                                방문하여 수령할 수 있습니다.</p>
                            </dd>
                        </dl>
                        <img src="../../assets/pc_barocare_new/img-user1.jpg" alt="">
                    </div>
                    <div class="item">
                        <dl v-intersect>
                            <dt class="text-xl">환자 가족</dt>
                            <dd>
                                <p>시간이 많이 걸리는 병원 동행 대신 간단한 동의 절차로<br>
                                사랑하는 가족의 건강 관리가 가능합니다.</p>
                                <p>진료 내용, 처방 문서, 영수증 등을<br>
                                휴대폰을 통해 확인 가능합니다.</p>
                            </dd>
                        </dl>
                        <img src="../../assets/pc_barocare_new/img-user2.jpg" alt="">
                    </div>
                    <div class="item">
                        <dl v-intersect>
                            <dt class="text-xl">담당 기관</dt>
                            <dd>
                                <p>고혈압, 당뇨 등 만성질환부터 감기 같은 급성 질환까지<br>
                                의료진을 빠르게 만나볼 수 있습니다.</p>
                                <p>기관별 담당자가 프로그램 이용을 지원하며<br>
                                진료 내역 등을 실시간 확인할 수 있습니다.</p>
                            </dd>
                        </dl>
                        <img src="../../assets/pc_barocare_new/img-user3.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="review-story">
            <h3 class="title text-xl" v-intersect>바로돌봄을 도입한 곳의<br> 이야기를 들어보세요</h3>
            
            <div class="slide-wrap" v-intersect>
                <ul class="review-list to-right">
                    <li v-for="item in repeatedItems1" :key="item.id">
                        <span class="location">{{ item.location }}</span>
                        <strong class="user">{{ item.user }}</strong>
                        <p class="comment">{{ item.comment }}</p>
                    </li>
                </ul>
                <ul class="review-list to-left">
                    <li v-for="item in repeatedItems2" :key="item.id">
                        <span class="location">{{ item.location }}</span>
                        <strong class="user">{{ item.user }}</strong>
                        <p class="comment">{{ item.comment }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="use-cases">
            <h3 class="text-xl" v-intersect>이미 많은 곳에서<br> 바로돌봄을 사용 중입니다</h3>
            <div class="img-area" v-intersect>
                <img src="../../assets/pc_barocare_new/bg-review-story.jpg" alt="">
            </div>
        </div>
        <div class="partnership">
            <div class="container">
                <h3 class="title text-xl" v-intersect>주요 파트너십</h3>
                <ul class="bi-list" v-intersect>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership-nh.png" alt="NH농협"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership1.png" alt="대교 뉴이프"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership2.png" alt="케어링"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership3.png" alt="대구광역시"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership4.png" alt="경북대학교병원"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership5.png" alt="연세대학교"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership6.png" alt="경상국립대학교"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership7.png" alt="원격의료산업협의회"></li>
                    <li><img src="../../assets/pc_barocare_new/bi-partnership8.png" alt="한국보건산업진흥원"></li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ServiceIntro',
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
    data() {
        return {
            items1: [
                { id: 1, location: '대구', user: 'K주간보호센터 임OO 보호자님', comment: '병원 방문시 차사고나 낙상의 위험이 항상 우려되었는데 그 부분이 해결되어 좋습니다. 약도 정확하고 신속하게 배달되어 분실의 위험이 없어 안심입니다.' },
                { id: 2, location: '경기도', user: 'N데이케어센터 박OO님', comment: '바로돌봄을 통해 고혈압약을 처방받고 있습니다. 기존에 3달에 한번씩 병원에 방문했는데, 이제는 한달에 1번씩 건강상담을 받을 수 있어서 좋습니다.' },
                { id: 3, location: '경기도', user: 'S요양원 최OO님', comment: '보호자분이 타지에서 근무하는 경우인데 비대면진료로 병원 동행의 부담이 경감되어 만족도가 높습니다.' },
                { id: 4, location: '경상남도', user: 'M주간보호센터 김OO님', comment: '90대 고령의 중증 치매환자의 경우 거동이 불편하여 병원 방문이 어려웠는데, 바로돌봄을 통해 치매약을 처방받아 병원 방문의 부담이 덜어졌습니다.' },
                { id: 5, location: '경상북도', user: 'H재가복지센터 김OO님', comment: '병원 방문시 차사고나 낙상의 위험이 항상 우려되었는데 그 부분이 해결되어 좋습니다. 약도 정확하고 신속하게 배달되어 분실의 위험이 없어 안심입니다.' },
            ],
            items2: [
                { id: 6, location: '대구', user: 'H노인복지센터 구OO님', comment: '평소 여러 곳의 병원을 다니는데 여기저기 방문하지 않아도 센터에서 편하게 진료를 볼 수 있고 약도 늦지 않게 배달 받을 수 있어서 좋았습니다.' },
                { id: 7, location: '대구', user: 'H요양원 정OO님', comment: '병원에서 오래 대기하며 고생할 일이 없어서 좋습니다. 비대면 소통에 대한 우려가 있었는데 의료진이 친절하고 꼼꼼하여 안심이 되고 만족스러웠습니다.' },
                { id: 8, location: '경상남도', user: 'S주간보호센터 김OO 보호자님', comment: '병원 방문시 사고나 낙상의 위험이 신경쓰이고 대기시간이 걱정되었는데 센터에서 안전하고 편하게 진료를 보실 수 있어서 좋았습니다.' },
                { id: 9, location: '대구', user: 'Y데이케어센터 김OO님', comment: '병원 방문 시간에 맞춰 식사나 기타 일정을 서둘러야 할 필요 없이 비대면으로 언제든지 진료를 볼 수 있고 약을 기다리는 시간도 줄어들어 개인시간이 늘어서 좋았습니다.' },
                { id: 10, location: '경기도', user: 'O방문요양센터 이OO님', comment: '환자가 많은 병원에 방문할 때에 비해 센터에서 조용히 개인적인 진료를 받을 수 있기 때문에 진료시간의 질이 높아진 것 같아 만족스럽습니다.' },
            ],
            repeatCount: 20
        }
    },
    computed: {
        repeatedItems1() {
            let result = [];
            for (let i = 0; i < this.repeatCount; i++) {
                this.items1.forEach(item => {
                    result.push({
                        ...item,
                        id: `${item.id}-${i}`
                    });
                });
            }
            return result;
        },
        repeatedItems2() {
            let result = [];
            for (let i = 0; i < this.repeatCount; i++) {
                this.items2.forEach(item => {
                    result.push({
                        ...item,
                        id: `${item.id}-${i}`
                    });
                });
            }
            return result;
        }
    },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_new/ServiceIntro.vue